import React from 'react';
import { Card, Row, Col, Space, Tag, Table, Button } from 'antd';
import { SHIPPING_METHOD_NAME } from '../../common/constants'; 

// 运送方式限制
function ShippingLimit(props: any) {
    const { cart, checkedProviderResults, handleShippingChange } = props || {};
    const { shippingMethodLabel, shippingMethod, shippingMethodOptions, forwardingProvider } = cart?.groups?.[0] || {};
    const CCResult = checkedProviderResults?.find(item => item.method === 'BIEYANG');
    const BCResult = checkedProviderResults?.find(item => item.method === 'SUNSHINE_CUSTOM');;

    const shippingColumns = [{
        title: '运送方式',
        dataIndex: 'name',
        key: 'name',
        width: '10%'
    }, {
        title: '支持使用',
        dataIndex: 'ineligible',
        key: 'ineligible',
        render: (record) => {
            return record ? <Tag color="error">不支持</Tag> : <Tag color="success">支持</Tag>
        }
    }, {
        title: '总价格',
        dataIndex: 'costValue',
        key: 'costValue',
    }, {
        title: '详细信息',
        dataIndex: 'itemized',
        key: 'itemized',
        width: '20%',
        render: (record) => {
            return <Space direction="vertical">
                {record && record.length ? record?.map(item => {
                    return (
                        <div>{item.label}{item?.costValue ? '：' + item?.costValue : ''}</div>
                    )
                }) : null}
            </Space>
        }
    }, {
        title: '前端提示',
        dataIndex: 'ineligibleReason',
        key: 'ineligibleReason',
        render: (record) => <div>{record?.text}</div>
    }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        render: (record, item) => {
            if(item?.name !== shippingMethod && !item?.ineligible) {
                return <Button onClick={() => handleShippingChange(item)}>切换到当前物流</Button>
            }
            return null;
        }
    }] 

    if(!cart) return null;

    return <Card title="运送方式限制" style={{ width: '100%' }}>
        <Space direction="vertical" size='middle' style={{ width: '100%' }}>
            <Row>
                <Col span={8}>当前运送方式：{shippingMethodLabel} {shippingMethod}</Col>
                <Col span={8}>当前分配渠道：{forwardingProvider}</Col>
            </Row>
            <Table
                dataSource={shippingMethodOptions}
                columns={shippingColumns}
                pagination={false}
            />
            {CCResult && <ProviderLimit {...CCResult} />}
            {BCResult && <ProviderLimit {...BCResult} />}
        </Space>
    </Card>
}

function ProviderLimit(data) {
    const { method, checkedProviderAddress } = data || {};
    const providerColumns = [{
        title: '渠道',
        dataIndex: 'provider',
        key: 'provider',
        width: '20%',
        render: (record, item) => <div>{item?.providerAddress?.provider}</div>
    }, {
        title: '是否支持',
        dataIndex: 'unqualified',
        key: 'unqualified',
        render: (record, item) => {
            const unqualified = item?.checkResult?.unqualified;
            return unqualified ? <Tag color="error">不支持</Tag> : <Tag color="success">支持</Tag>
        }
    }, {
        title: '限制原因',
        dataIndex: 'reason',
        key: 'reason',
        render: (record, item) => {
            const reason = item?.checkResult?.reason;
            return <div>{reason}</div>
        }
    }, {
        title: '细节',
        dataIndex: 'details',
        key: 'details',
        render: (record, item) => {
            const details = item?.checkResult?.details;
            return <div>{details}</div>
        }
    }]
    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <div>{SHIPPING_METHOD_NAME[method]}渠道限制</div>
            <Table
                dataSource={checkedProviderAddress}
                columns={providerColumns}
                pagination={false}
            />
        </Space>
    )
}

export default ShippingLimit;